<template>
  <div class='ai-product-intro'>
    <h2>人工智能平台介绍</h2>
    <div class="box">
      <img src="../../assets/images/ai-introduce.png"/>
    </div>
    <div class="content"> 源于硅谷、扎根中国，上海殷泊信息科技有限公司 (MoPaaS魔泊云) 是中国领先的人工智能(AI) 平台和服务提供商，为用户的数字转型、智能升级和融合创新直接赋能。针对中国AI应用和工程市场的需求，基于自主的智能云平台专利技术，MoPaaS 魔泊云在业界率先推出新一代开放的AI平台为加速客户AI技术创新和应用落地提供高效的GPU算力优化和规模化AI模型开发运维 (ModelOps) 能力和服务。MoPaaS魔泊云 AI平台已经服务在教学科研、工业制造、能源交通、互联网、医疗卫生、政府和金融等行业超过1000家国内外满意的客户的AI技术研发、人才培养和应用落地工程需求。MoPaaS魔泊云致力打造全方位开放的AI技术和应用生态。同时，MoPaaS魔泊云在浙江嘉兴设立安尚云信信息科技有限公司全资子公司，致力于推动当地的科技产业发展，并积极培养本地专业技术人才，创造更大的社会和经济效益。MoPaaS 被Forrester评为中国企业级云平台市场的卓越表现者(Strong Performer)。</div>
  </div>
</template>

<script>
export default {
  name: 'HomeProductIntrodution'
}
</script>

<style>
.ai-product-intro {
  background: #F5F6F9;
  padding: 6vw 3vw;
}

.ai-product-intro h2 {
  margin: 0 auto 6vw;
  font-size: 16px;
  font-weight: 500;
  color: #3A3F4D;
  line-height: 20px;
}

.ai-product-intro .box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100vw;
}

.ai-product-intro .box img {
  width: 94vw;
  height: 55vw;
}
.ai-product-intro .content {
  font-size: 12px;
  font-weight: 400;
  color: #333333;
  line-height: 18px;
  text-align: left;
  margin: 4vw 2vw 0;
}
</style>
<style></style>


// WEBPACK FOOTER //
// src/page/h5/ai-product-introduction.vue